import { IS_NEW_BACKEND_API } from '@skytech/utils'

import { post } from '@/util/auth'

import { API_PATH_ECOM_PRODUCT_PRICE_VALIDATION } from './apiRoutes'

export const ecomProductResources = {
  // Mutation
  postProductValidation: (body: PriceValidationRequest) =>
    post<PriceValidationResponseOriginal>(
      API_PATH_ECOM_PRODUCT_PRICE_VALIDATION,
      body,
      IS_NEW_BACKEND_API
    ),
}

type PriceValidationResponseOriginal = {
  validationResults: ValidationResultOriginal[]
}

type ValidationResultOriginal = {
  productId: number
  isValid: boolean
  latestPrice: number
}

export type PriceValidationRequest = {
  products: {
    id: number
    proposedPrice: number
  }[]
}
